import { render, staticRenderFns } from "./GnbSearch.vue?vue&type=template&id=65bb519c"
import script from "./GnbSearch.ts?vue&type=script&lang=ts&external"
export * from "./GnbSearch.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports